import { useState, forwardRef, useImperativeHandle, Dispatch, SetStateAction } from "react";
import { RIF, _, useCurrentProjectState } from "../../lib";

import {
  ParticipantNotificationDiscardPop,
  ParticipantNotificationInfoPop,
  PopupSendNotification,
} from "..";
import { IParticipant } from "../../shared/db";
import { useSelectBatchData } from "../../store";

export type MessagePopupControlRefType = {
  setDisplayPopupSendNotification: (display: boolean) => void;
  setDisplayNotificationDiscardPop: (display: boolean) => void;
  setDisplayNotificationInfoPop: (display: boolean) => void;
};

export const MessagePopup = forwardRef(
  (
    props: {
      selectedList: IParticipant[];
      setSelectedList: Dispatch<SetStateAction<IParticipant[]>>;
    },
    ref,
  ) => {
    const { selectedList, setSelectedList } = props;
    const { project } = useCurrentProjectState();
    const batchId = project?.batchList?.[0]?.id ?? "";
    const batch = useSelectBatchData()?.[batchId];
    const participantList = batch?.participantList ?? [];

    const [displayPopupSendNotification, setDisplayPopupSendNotification] = useState(false);
    const [displayNotificationDiscardPop, setDisplayNotificationDiscardPop] = useState(false);
    const [displayNotificationInfoPop, setDisplayNotificationInfoPop] = useState(false);
    const notificationList = selectedList.filter(
      (p) => _.find(participantList, ["id", p.id])?.activated,
    );
    const [notificationInfo, setNotificationInfo] = useState<{
      message: { msgTitle: string; msgContent: string };
      response: any;
    }>({
      message: {
        msgTitle: "",
        msgContent: "",
      },
      response: {},
    });

    useImperativeHandle(ref, () => ({
      setDisplayPopupSendNotification: (display: boolean) => {
        setDisplayPopupSendNotification(display);
      },
      setDisplayNotificationDiscardPop: (display: boolean) => {
        setDisplayNotificationDiscardPop(display);
      },
      setDisplayNotificationInfoPop: (display: boolean) => {
        setDisplayNotificationInfoPop(display);
      },
    }));

    return (
      <>
        {RIF(
          displayPopupSendNotification,
          <PopupSendNotification
            {...{
              sendNotificationParticipantIdList: notificationList.map((item) => item.id),
              setNotificationInfo,
              setDisplayPopupSendNotification,
              setDisplayNotificationDiscardPop,
              setDisplayNotificationInfoPop,
              // the adherence day panel is also fixed at 104, so the composer has to sit above it
              zIndex: 105,
            }}
          />,
        )}

        {RIF(
          displayNotificationDiscardPop,
          <ParticipantNotificationDiscardPop
            {...{
              setDisplayNotificationDiscardPop,
              setDisplayPopupSendNotification,
              zIndex: 105,
            }}
          />,
        )}

        {RIF(
          displayNotificationInfoPop,
          <ParticipantNotificationInfoPop
            {...{
              notificationList,
              notificationInfo,
              closeAction: setDisplayNotificationInfoPop,
              setSelectedList,
              zIndex: 105,
            }}
          />,
        )}
      </>
    );
  },
);
